import React from 'react';
import { Typography } from 'antd';
import Container from 'common/components/container.component';
import { User } from 'store/models/user.model';

import clsx from 'clsx';
import { RouteName } from 'config/constants/route.constants';
import { OrderTranscription } from 'config/constants/transcription.constant';
import { useNavigate } from 'react-router';
import PaymentActions from '../payment-actions.component';
import styles from './style.module.scss';

const { Title } = Typography;

type PurchaseTimeoutResultProps = {
  user: User;
};

const PurchaseTimeoutResult: React.FC<PurchaseTimeoutResultProps> = ({ user }) => {
  const navigate = useNavigate();

  return (
    <Container>
      <div className={styles['status-view-wrapper']}>
        <div className={clsx(styles['status-card'], styles['timeout'])}>
          <div className={styles['icon-container']}>
            <div className={styles['circle-icon']}>!</div>
          </div>
          <Title level={2} className={styles['status-title']}>
            {OrderTranscription.PURCHASE_TIMEOUT}
          </Title>
          <div className={styles['status-description']}>
            <p>
              Lo sentimos <strong>{user.name}</strong>, el tiempo para completar el pago ha expirado.
            </p>
          </div>
          <PaymentActions onRetryPurchase={() => navigate(RouteName.PURCHASE_CHECKOUT)} onGoHome={() => navigate(RouteName.HOME)} />
        </div>
      </div>
    </Container>
  );
};

export default PurchaseTimeoutResult;
